var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dc3545",
    d: "M97.3,11.2c-4.3,1.5-9.4,5-11.7,8c-1.2,1.6-3.8,7-7.5,16l-5.7,13.6L47.6,49l-24.9,0.2l-1.4,1.6C20,52.3,20,52.3,20,58.8C20,68.9,20.1,69,31.7,69h7.9v74.3c0,80.3,0,77.9,2.6,84.8c2.5,6.7,8.1,13.2,13.3,15.7c1.3,0.7,3.8,1.4,5.3,1.7c3.8,0.7,131.3,0.7,135,0c9.6-1.8,17.9-11.8,20.2-24.3c0.5-2.9,0.6-17.4,0.7-77.9V69h8.4h8.4l1.4-1.4l1.4-1.4v-7c0-3.9-0.2-7.4-0.5-7.8c-1.1-2.1-1.5-2.1-27.3-2.4l-24.7-0.2l-5.7-13.6c-6.4-15.3-7.6-17.3-12.8-20.9c-6.2-4.4-5.4-4.3-37-4.3h-27.4L97.3,11.2z M153.6,30.2c1.1,0.6,2,2.2,5,9.6c2,4.9,3.6,9,3.5,9.1c-0.1,0.1-15.5,0.1-34.2,0l-34-0.1l3.4-8.3c3.9-9.5,4.1-9.9,5.6-10.5c0.6-0.2,11.9-0.4,25.2-0.4C148.1,29.5,152.5,29.6,153.6,30.2z M196.9,143.8l-0.1,74.8l-1.1,2.3c-0.6,1.2-1.5,2.9-2,3.7l-1,1.4h-64.4H63.9l-1.2-1.4c-0.7-0.8-1.7-2.6-2.2-4c-1-2.7-1-2.9-1-77.1V69h68.7H197L196.9,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M80.4,99.9l-1.4,1.4v46.2v46.2l1.4,1.4l1.4,1.4h7h7l1.4-1.4l1.4-1.4v-46.2v-46.2l-1.4-1.4l-1.4-1.4h-7h-7L80.4,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M119.8,99.9l-1.6,1.4v45.9c0,49.4-0.1,47.7,2.5,48.8c0.7,0.3,3.9,0.5,7.8,0.5h6.7l1.4-1.4l1.4-1.4l-0.1-46.4l-0.1-46.5l-1.3-1.1c-1.3-1.1-1.6-1.1-8.2-1.1h-6.9L119.8,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M159.9,99.2c-2.5,1.4-2.4-0.4-2.4,48.2c0,48.7,0,47.3,2.3,48.6c0.5,0.2,4,0.5,7.7,0.5h6.8l1.4-1.4l1.4-1.4v-46.2v-46.2l-1.4-1.4l-1.4-1.4h-6.6C163.1,98.5,160.7,98.7,159.9,99.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9086064fd816a3f50d7f5abaaa1679f4.svg";
export { ForwardRef as ReactComponent };